const getPanopticLinkStateView = (linkState, degraded = false) => {
  if (linkState === 'connected') {
    return { status: 'online', label: 'Connected' };
  }
  if (linkState === 'offline') {
    return { status: 'offline', label: 'Disconnected' };
  }
  if (linkState === 'restricted') {
    return { status: 'restricted', label: 'Restricted' };
  }
  if (linkState === 'stale') {
    return { status: 'degraded', label: 'Stale' };
  }
  if (linkState === 'degraded' || degraded) {
    return { status: 'degraded', label: 'Degraded' };
  }
  return { status: 'unknown', label: 'Checking' };
};

export { getPanopticLinkStateView };
